import { libPrefix } from '@app/core/pcs-modal/constants';
import { ModalPayload } from '@app/core/pcs-modal/model/modal-payload';
import { Action } from '@ngrx/store';

export const PcsModalActionTypes = {
  OpenModal: `${libPrefix}/modal/open-modal`,
  CloseModal: `${libPrefix}/modal/close-modal`,
  CloseModalWithReason: `${libPrefix}/modal/close-modal-with-reason`
};

export class OpenModal implements Action {
  readonly type = PcsModalActionTypes.OpenModal;
  constructor(public payload: ModalPayload) {}
}

export class CloseModal implements Action {
  readonly type = PcsModalActionTypes.CloseModal;
}

export class CloseModalWithReason implements Action {
  readonly type = PcsModalActionTypes.CloseModalWithReason;
  constructor(public payload: string) {}
}

export type PcsModalActions =
  OpenModal
  | CloseModal
  | CloseModalWithReason;
